import { B400 } from '@atlaskit/theme/colors';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import HeaderContent from 'common/components/Header/components/HeaderContent/HeaderContent';
import CommonPropTypes from '../../../../../../constants/PropTypes';
import PartnerQuickLinks from './PartnerQuickLinks/components/PartnerQuickLinks/PartnerQuickLinks';

const HeaderContainer = styled.header`
  background-color: ${B400};
`;

export default class Header extends Component {
  static propTypes = {
    getUserData: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    userData: ImmutablePropTypes.map.isRequired,
    children: PropTypes.node,
    history: CommonPropTypes.history.isRequired,
    displayPartnerQuickLinks: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <HeaderContainer>
        {this.props.displayPartnerQuickLinks && (
          <PartnerQuickLinks userData={this.props.userData} />
        )}
        <div id="header-menu">
          <HeaderContent
            getUserData={this.props.getUserData}
            onLogout={this.props.onLogout}
            userData={this.props.userData}
            history={this.props.history}
          >
            {this.props.children}
          </HeaderContent>
        </div>
      </HeaderContainer>
    );
  }
}
